import { Link } from 'react-router-dom';

// icons
import { faFileCircleQuestion } from '@fortawesome/pro-regular-svg-icons';
import { Grid, useTheme } from '@mui/material';

// components
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useActor } from '../../../../components/hooks/useActor';
import { ProductTypes } from '../../../../types';
import { SolidButton, StyledHeader, StyledParagraph } from './styles';

export const RenewBound = ({ policy }: any) => {
  const actor = useActor();
  const theme = useTheme();

  const route =
    policy.product === ProductTypes.p100 ? 'accountDetails' : 'attest';

  let availableUrl = `/customer/quotes/${policy.quoteId}/renewals/${policy.product}/${route}`;

  if (policy.customerEmail !== actor.email) {
    availableUrl = `/customer/quotes/${policy.quoteId}/insuredName/${policy.product}`;
  }

  return (
    <Grid container columnSpacing={2} rowSpacing={2}>
      <Grid
        item
        md={3}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <FontAwesomeIcon
          icon={faFileCircleQuestion}
          size="4x"
          color={theme.palette.common.gunmetalBlue}
        />
      </Grid>
      <Grid item md={9}>
        <StyledHeader>Policy Renewal</StyledHeader>
        <StyledParagraph>
          Renewal Quote(s) has been approved by your agent and is ready for
          attestion
        </StyledParagraph>
        <Link style={{ display: 'block' }} to={availableUrl}>
          <SolidButton
            type="submit"
            sx={{ marginTop: '1rem', width: '100% !important' }}
          >
            Renew
          </SolidButton>
        </Link>
      </Grid>
    </Grid>
  );
};
